import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin } from '../../Util';
import { StoreStore, AuthStore } from '../../stores';
import { StoreActions } from '../../actions';
import Loader from '../Material/Loader';
import FullScreenDialog from '../FullScreenDialog';
import {english, swedish} from "./renderTaC";

const css = oxygenCss({
  content: {
    width: 960,
    maxWidth: '100%',
    boxSizing: 'border-box',
    padding: 64,
    margin: 'auto'
  }
});

export default class StoreTaC extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    router: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStoreWithMapper(
      StoreStore,
      state => {
        return {
          docs: state.docs || {},
          logo: state.theme && state.theme.logoUrl,
          title: state.owner && state.owner.name,
          username: state.owner && state.owner.username
        };
      },
      {
        docs: {}
      }
    );
    this.listenToStoreWithMapper(
      AuthStore,
      state => ({
        locale: state.locale
      }),
      {
        locale: 'en_US'
      }
    );
  }

  componentDidMount() {
    const { username } = this.props;
    StoreActions.read(username, true);
  }

  render() {
    const { docs, title, locale } = this.state;
    const { termsAndConditions } = docs;
    const pageContent = locale === 'sv_SE' ? swedish : english;

    return (
      <FullScreenDialog {...this.props}>
        {
          title
            ? <div className={css.content}>
                {termsAndConditions ? <div dangerouslySetInnerHTML={{ __html: termsAndConditions }} /> : pageContent}
              </div>
            : <Loader />}
      </FullScreenDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/TaC/StoreTaC.js